import { BaseEntity } from "yt-ng-framework";

export class EOtpremnicaOpasnaMaterija extends BaseEntity {

    constructor() {
        super();
    }

    EOtpremnicaID: number = null;
    Naziv: string = null;
    Vrednost: string = null;
    Komentar: string = null;

    Deserialize(input: any) {
        super.Deserialize(input);

        this.ID = input.ID;
        this.EOtpremnicaID = input.EOtpremnicaID;
        this.Naziv = input.Naziv;
        this.Vrednost = input.Vrednost;
        this.Komentar = input.Komentar;

        return this;
    }

    Serialize(input: EOtpremnicaOpasnaMaterija) {
        return input;
    }
}
